import { getCookie, hasCookie } from 'cookies-next';
import { LOCALE_KEY, type Locales } from '@/components/ui/LocaleButton';

export const getLocaleFromClientCookie = () => {
  const locale = hasCookie(LOCALE_KEY) ? getCookie(LOCALE_KEY)?.trim() : 'pt-BR';
  return locale as Locales;
};
